// ==========================================================================
// AUTOCOMPLETE
// ==========================================================================

(function(NAMESPACE, $) {

	'use strict';

	NAMESPACE.mobileMultilingualModal = (function() {
		var init,
			SELECTORS;

		SELECTORS = {
            ONSCREEN_NAV: '.nav-toggle',
            LANGUAGE_SELECT_ELEMENT: 'select.goog-te-combo',
			MODAL: 'modal-multilingual-disclaimer'
        };

		init = function() {
            $(SELECTORS.ONSCREEN_NAV).on('click', function() {
                $(SELECTORS.LANGUAGE_SELECT_ELEMENT).on('change', function() {
					NAMESPACE.modal.open(SELECTORS.MODAL);
				});
            });
		};

		return {
			init: init
		};

	}());

}(DDIGITAL, jQuery));
